import styled from 'styled-components';

export const KitchenHeader = styled.div`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  width: 100%;
  gap: 1rem;

  img {
    height: 3.5rem;
  }
`;

export const KitchenWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
`

export const KitchenContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StyledKitchenTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  font-family: "NeueMachina";
  text-transform: uppercase;;
  color: white;

  .shop-title-bold {
    font-weight: 800;
  }

  .shop-title-gold {
    color: ${({ theme }) => theme.selection};
  }
`;

export const KitchenTitleText = styled.div`
  font-size: 1.5rem;
  font-weight: 400;
`;

export const KitchenMainSection = styled.div`
  flex-grow: 1;
  position: relative;
  width: 100%;
`;

export const KitchenBg = styled.img`
  position: absolute;
  top: 0;
  left:0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const KitchenControls = styled.div`
  padding: 2rem;
  background: ${({ theme }) => theme.background};
  width: 100%;

  @media (max-height: 600px) {
    padding: 1.2rem;
  }
`;

export const StyledKitchenSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
`;

export const StyledKitchenSectionObjects = styled.div`
  width: 100%;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
`;

export const KitchenSectionObjectsRow = styled.div`
  width: 100%;
  display: flex;
  overflow-y: auto;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  gap: 1.25rem;
  padding-bottom: 1.25rem;
`;

export const StyledKitchenOffers = styled.div`
  position: absolute;
  top: 0;
  left:0;
  width: 100%;
  height: 100%;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  gap: 1rem;
  padding: 2.5rem;

  @media (max-height: 600px) {
    padding: 1.5rem;
  }
`;

export const StyledKitchenRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StyledKitchenItem = styled.div`
  min-width: 5.75rem;
  height: 10vh;
  width: 18%;
  min-height: 6.875rem;
  position: relative;
  border: solid 2px ${({ $hovered }) => $hovered ? 'white' : 'transparent'};
`;

export const KitchenItemBg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: .3s linear;
  background: ${({ theme }) => theme.baseGreen};
  z-index: -1;
  opacity: ${({ $hovered }) => $hovered ? '1' : '0'};
`;

export const KitchenItemImageHolder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
  border: solid 2px ${({ $hovered }) => $hovered ? 'black' : 'transparent'};

  img {
    transition: .2s linear;
    scale: ${({ $hovered }) => $hovered ? '1.2' : '1.0'};
  }
`;

export const KitchenItemCount = styled.div`
  position: absolute;
  bottom: 0;
  right: 20%;
  color: black;
  font-family: "BebasNeue";
  font-size: 2rem;
  text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
             1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;
  
`;

export const KitchenItemBuy = styled.div`
  position: absolute;
  bottom: 0;
  right: 20%;
  color: black;
  font-family: "BebasNeue";
  font-size: 2rem;
  padding: 0.1rem;
  padding-top: 0.5rem;
  line-height: 0.6;
  background: ${({ theme }) => theme.baseGreen};
  border: solid 2px rgba(0,0,0,0.25);
`;

export const KitchenItemImage = styled.img`
  filter: ${({ $locked }) => $locked ? 'brightness(25%)' : 'unset'};
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const KitchenItemLock = styled.img`
  position: absolute;
  bottom: 0;
  right: 20%;
  bottom: 0.5rem;
  height: 2rem;
  width: 1.75rem;
  object-fit: contain;
`;
